import Confetti from '@components/common/confetti'
import Logo from '@components/common/logo'
import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'
import { toTitleCase } from '@common/utils'
import classNames from 'classnames'

const PAYMENT_STATUS = {
  SUCCESSFUL: 'successful',
  CANCELLED: 'cancelled',
}

const STATUS_STRING = {
  [PAYMENT_STATUS.SUCCESSFUL]: 'Payment Successful 🎉',
  [PAYMENT_STATUS.CANCELLED]: 'Payment Cancelled 😔',
}

export default function PaymentSuccess() {
  const router = useRouter()
  const status = router.query?.status as string

  const [remainingTime, setRemainingTime] = useState(30)

  useEffect(() => {
    const timer = setInterval(() => {
      setRemainingTime((prevTime) => {
        if (prevTime == 0) {
          clearInterval(timer)
          location.replace('https://codingal.com/student/dashboard/')
          return 0
        }
        return prevTime - 1
      })
    }, 1000)

    return () => clearInterval(timer)
  }, [])

  if (!status) return null

  return (
    <body
      style={{
        background:
          'linear-gradient(to right, rgb(255, 228, 230), rgb(204, 251, 241))',
      }}
    >
      {status === PAYMENT_STATUS.SUCCESSFUL && (
        <Confetti shouldShowConfetti={true} recycle={false} />
      )}
      <nav className="ml-3 mt-3 absolute">
        <a
          href="https://codingal.com"
          className="cursor-pointer inline-block"
          target="_blank"
          rel="noreferrer"
        >
          <Logo
            withText={true}
            style={{ width: '120px', height: '32px' }}
            alt="Codingal"
            height={32}
            width={120}
          />
        </a>
      </nav>
      <section className="flex flex-col h-screen items-center justify-center text-center px-2">
        <Logo
          withText={true}
          style={{ width: '120px', height: '32px' }}
          alt="Codingal"
          height={32}
          width={120}
        />
        <div>
          <h1
            className={classNames('font-700 text-3xl lg:text-5xl my-5', {
              'text-green-200': status === PAYMENT_STATUS.SUCCESSFUL,
              'text-orange': status !== PAYMENT_STATUS.SUCCESSFUL,
            })}
          >
            {STATUS_STRING[status] || `Payment ${toTitleCase(status)}`}
          </h1>
          <p className="font-500 text-sm lg:text-base text-grey">
            Close this window and go to your{' '}
            <span className="text-orange">Codingal dashboard</span>. <br />{' '}
            You&apos;ll be redirected automatically in {remainingTime} seconds
          </p>
        </div>
      </section>
    </body>
  )
}
